import { useQuery } from '@apollo/client';
import { GetAssessmentByIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { useIsFeatureVisibleToOrg } from '@/utils/featureFlags';

import { useGetAssessmentById as useGetAssessmentByIdTRPC } from './useGetAssessmentByIdTRPC';

export const useGetAssessmentById = (options: {
  variables: { Id: string };
  skip?: boolean;
}) => {
  const trpcEnabled = useIsFeatureVisibleToOrg('trpc');
  const {
    variables: { Id },
    skip = false,
  } = options;

  // Use TRPC when feature flag is enabled, otherwise use GraphQL
  const trpcResult = useGetAssessmentByIdTRPC(Id, !trpcEnabled || skip);
  const graphqlResult = useQuery(GetAssessmentByIdDocument, {
    variables: { Id },
    skip: trpcEnabled || skip,
    fetchPolicy: 'no-cache',
  });

  return trpcEnabled ? trpcResult : graphqlResult;
};
